import React, { Component } from "react";
import { I18nContext } from "./I18nProvider";

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

export default function translate(WrappedComponent) {
  const translateDisplayName = `Translate(${getDisplayName(WrappedComponent)})`;
  return class Translate extends Component {
    static contextType = I18nContext;

    static displayName = translateDisplayName;

    constructor(props, context) {
      super(props, context);

      console.log(context)

      this.translate = this.translate.bind(this);

      if (typeof this.context.i18n === "undefined")
        throw new Error(
          `[i18n] Impossible de trouver "i18n" dans le context ou ` +
            `dans les props de "${translateDisplayName}"` +
            `Englobez le composant racine dans un <I18nProvider>, ` +
            `ou passer "i18n" dans les props de "${translateDisplayName}".`
        );

      if (typeof this.context.interpolate === "undefined")
        throw new Error(
          `[i18n] Impossible de trouver "interpolate" dans le context.` +
            `[i18n] Impossible de trouver "interpolate" dans le context.` +
            `Englobez le composant racine dans un <I18nProvider>.`
        );
    }

    translate(key) {
      if (typeof this.context.i18n[key] === "undefined") {
        console.warn(`[i18n] Clé de traduction "${key}" introuvable.`);
        return key;
      }

      return this.context.interpolate.format(this.context.i18n[key]);
    }

    render() {
      return <WrappedComponent {...this.props} t={this.translate} />;
    }
  };
}
